import { InterviewerType } from "../../../entities/interviewer";
import InterviewerRepository from "../../ports/interviewerRepository";

export type fetchInterviewersUsecase = () => Promise<InterviewerType[]>;

export const buildFetchInterviewers = (dependencies: {
  interviewerRepo: InterviewerRepository;
}): fetchInterviewersUsecase => {
  const { interviewerRepo } = dependencies;

  const fetchInterviewers: fetchInterviewersUsecase = async () =>
    interviewerRepo.fetchInterviewers();

  return fetchInterviewers;
};
